/**
 * ChallengeCard accessibility helpers (A11Y-1).
 */

/**
 * Screen-reader label for the challenge card's expand/collapse press target.
 * Conveys the challenge name and the action the tap performs.
 */
export const buildChallengeCardA11yLabel = (
  displayName: string,
  isExpanded: boolean
): string => {
  const name = displayName.trim() || 'Challenge';
  const action = isExpanded ? 'collapse details' : 'expand details';
  return `${name}, ${action}`;
};
